<template>
  <svg id="igr_icon_neu_im_sortiment" data-name="igr_icon_neu im sortiment" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.7 44.02">
    <g>
      <circle class="cls-3" cx="31.27" cy="26.89" r="3.52"/>
      <circle class="cls-3" cx="20.79" cy="16.88" r="3.52"/>
      <line class="cls-1" x1="19.08" y1="28.84" x2="32.98" y2="14.94"/>
    </g>
    <polygon class="cls-2" points="49.91 38.13 5.6 38.13 5.6 5.64 49.91 5.64 63.06 21.89 49.91 38.13"/>
    <polyline class="cls-2" points="1.1 33.58 1.1 1.1 45.41 1.1"/>
    <polyline class="cls-1" points="63.6 27.87 51.42 42.92 8.5 42.92"/>
    <circle class="cls-1" cx="50.47" cy="21.89" r="2.81"/>
  </svg>
</template>

<script>
export default {
  name: "discountedArticlesIcon"
}
</script>

<style scoped>
#igr_icon_neu_im_sortiment {
  scale: 0.65;
}
.cls-1, .cls-2 {
  stroke-linecap: round;
}

.cls-1, .cls-2, .cls-3 {
  fill: none;
  stroke: #a8a8a8;
  stroke-width: 2.2px;
}

.cls-1, .cls-3 {
  stroke-miterlimit: 10;
}

.cls-2 {
  stroke-linejoin: round;
}
</style>
